<template>
  <div v-if="show">
    <basic-banner v-model="show_obj.banner_title"></basic-banner>

    <div class="pi-pd-tb-40">
      <basic-core-business
        ref="core_business"
        v-model="show_obj.core_business"
      ></basic-core-business>
      <basic-row3 ref="row_3" v-model="show_obj.row_3"></basic-row3>
    </div>
    <basic-row4 ref="row_4" v-model="show_obj.row_4"></basic-row4>
    <basic-row5 ref="row_5" v-model="show_obj.row_5"></basic-row5>
    <basic-row6 ref="row_6"></basic-row6>
    <basic-row7 ref="row_7" v-model="show_obj.row_7"></basic-row7>
  </div>
</template>

<script>
import BasicRow4 from "./components/row_4";
import BasicRow3 from "./components/row_3";
import BasicRow5 from "./components/row_5";
import BasicRow6 from "./components/row_6";
import BasicRow7 from "./components/row_7";
import { scrollTop } from "@/utils/index";
import BasicBanner from "./components/banner";
import BasicCoreBusiness from "./components/core_business";
export default {
  data() {
    return {
      show: false,
      offsetTop: {
        core_business: 0,
        row_3: 0,
        row_4: 0,
        row_5: 0,
        row_7: 0,
      },
      show_obj: {
        row_5: false,
        row_4: false,
        row_3: false,
        row_7: false,
        banner_title: false,
        core_business: true,
      },
    };
  },
  components: {
    BasicRow7,
    BasicRow6,
    BasicRow5,
    BasicRow4,
    BasicRow3,
    BasicBanner,
    BasicCoreBusiness,
  },
  mounted() {
    this.show = true;
    this.$nextTick(() => {
      // 进入页面时，菜单是否透明，或不显示阴影，默认为false，这里是示例
      globalEvent.$emit("changeHeaderTransparent", {
        isTransparent: true,
        isNoShadow: false,
      });
      setTimeout(() => {
        this.loadScroll();
        this.loadTop();
        this.scrollTo();
      }, 500);
    });
  },
  destroyed() {
    this.show = false;
    this.offsetTop = {
      core_business: 0,
      row_3: 0,
      row_4: 0,
      row_5: 0,
      row_7: 0,
    };
  },
  methods: {
    scrollTo() {
      window.scrollTo(1, 0);
    },
    loadScroll() {
      scrollTop((res) => {
        for (const key in this.offsetTop) {
          if (!this.show_obj[key] && res.scrollH >= this.offsetTop[key]) {
            this.show_obj[key] = true;
          }
        }
        // for (const key in this.offsetTop) {
        //   this.show_obj[key] = res.scrollH > this.offsetTop[key];
        // }
      });
    },
    loadTop() {
      console.log("offsetTop");
      for (const key in this.offsetTop) {
        const client_height = document.documentElement.clientHeight;
        const height = this.$refs[key].loadInit().offsetHeight / 2;
        this.offsetTop[key] =
          this.$refs[key].loadInit().offsetTop - client_height + height;
      }
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/index/index.vue